import getHomeUrl from "../getHomeUrl";

const genAbsoluteUrl = (path) =>
{
    const baseUrl = getHomeUrl().replace(/\/$/gm, '');
  
    if (!path) return baseUrl;

    const normalizedPath = path.replace(/([^:]\/)\/+/g, '$1').replace(/\/$/gm, '');
    if (normalizedPath.startsWith('http')) return normalizedPath.replace(/\/$/gm, '');
    if (!normalizedPath.startsWith('/')) return `${baseUrl}/${normalizedPath.replace(/\/$/gm, '')}`;

    return `${baseUrl}${normalizedPath.replace(/\/$/gm, '')}`;
}

export default genAbsoluteUrl;